import React from 'react'
import './Footer.sass'
import Logo from '../../ui/Logo/Logo'
import SocialLinks from '../Top/SocialLinks/SocialLinks'
import PhoneLinks from '../Top/PhoneLinks/PhoneLinks'
import EmailLink from '../Top/EmailLink/EmailLink'
import { NavLink } from 'react-router-dom'
import Icon from '../../ui/Icon/Icon'
import { NavHashLink } from 'react-router-hash-link'
import scrollWithOffset from '../../ui/ScrollToTop/scrollWithOffset'
import AddressLink from '../Top/AddressLink/AddressLink'

function Footer() {
  return (
    <footer id="contacts" className="Footer">
      <div className="Main DefaultContainer">
        <Logo />
        <div className="ContactBlock">
          <PhoneLinks />
          <EmailLink />
          {/* <AddressLink /> */}
        </div>
      </div>

      <div className="Copyrights DefaultContainer">
        © 2025 Все права защищены.
      </div>
    </footer>
  )
}

export default Footer
